import React, { Component } from 'react';
import { currencyFormatter } from 'utils/formatter';
import FeatureDetailModal from 'components/FeatureDetailTransactionModal';
import PaymentGatewayErrorModal from 'components/PaymentGatewayErrorModal';
import { Link } from 'react-router';

import PageWrapper from 'components/wrappers/pages/PageWrapper/PageWrapper';
import AppleLogo from 'assets/images/ic_apple.png';
import styles from './FeatureBillingPage.css';

class FeatureBillingPage extends Component {
  static renderAdditionalInfo(featureName) {
    if (featureName === 'Table Management') {
      return (
        <div className={`${styles['additional-info']}`}>
          <p>
            <img src={AppleLogo} /> Compatible for <b>iPad</b> only.
          </p>
          <hr />
          <b>Min Requirements</b>
          <p>Moka app Ver. 15.00</p>
        </div>
      );
    }
  }

  render() {
    const {
      featureName,
      videoLink,
      featureMessage,
      featureLogo,
      featurePrice,
      featurePricePerMonths,
      currentOutletCount,
      isButtonDisabled,
      buttonMessage,
      billingMessages,
      showDetailModal,
      onHide,
      onShow,
      outletList,
      verifyBilling,
      showPaymentGatewayErrorModal,
      hidePaymentGatewayErrorModal,
      discountPriceLowerBound,
    } = this.props;
    return (
      <div>
        <PageWrapper>
          <div className={`${styles['splash-page']} splash ${featureName}`}>
            <div className={styles['splash-content']}>
              <p className="text-center">
                <img
                  src={featureLogo}
                  className={`img-circle ${styles['feature-logo']}`}
                />
              </p>
              <h3 className={`text-center ${styles['splash-title']}`}>
                {featureName}
              </h3>
              <p className={styles['feature-description']}>{featureMessage}</p>
              <p className={`text-center ${styles['splash-video']}`}>
                <iframe
                  width="248"
                  height="167"
                  src={videoLink}
                  frameBorder={0}
                  allowFullScreen
                  id="video"
                />
              </p>
              <p className={styles['pricing-message']}>Pricing</p>

              <table className={styles['pricing-table']}>
                <tr className={styles['pricing-row']}>
                  <td align="left" className={styles['pricing-colomn']}>
                    {featureName}
                  </td>
                  {featurePricePerMonths < discountPriceLowerBound && (
                    <td
                      className={`text-right ${styles['pricing-colomn']} ${
                        styles['pricing-colomn-discount']
                      }`}
                    >
                      {currencyFormatter(discountPriceLowerBound)}
                    </td>
                  )}
                  <td className={`text-right ${styles['pricing-colomn']}`}>
                    {currencyFormatter(featurePricePerMonths)}/mo
                  </td>
                </tr>
              </table>
              <table className={styles['pricing-table']}>
                <tr
                  className={`${styles['pricing-row']} ${styles['no-border']}`}
                >
                  <td
                    className={`${styles['total-pricing-colomn']} ${
                      styles['no-padding-bottom']
                    }`}
                  >
                    Total Payment
                  </td>
                  <td
                    className={`text-right ${styles['total-pricing-colomn']} ${
                      styles['no-padding-bottom']
                    }`}
                  >
                    {currencyFormatter(featurePrice.final_price)}
                  </td>
                </tr>
                <tr
                  className={`${styles['pricing-row']} ${styles['no-border']}`}
                >
                  <td
                    align="left"
                    className={`${styles['pricing-prorated']} ${
                      styles['paid-outlet-row']
                    }`}
                  >
                    Your paid for {currentOutletCount} Outlet
                    {currentOutletCount > 1 ? '(s)' : ''}
                  </td>
                </tr>
                <tr
                  className={`${styles['pricing-row']} ${
                    styles['last-row-pricing-table']
                  }`}
                >
                  <td
                    align="left"
                    className={`${styles['pricing-prorated']} ${
                      styles['add-padding-payment-detail']
                    }`}
                    colSpan="2"
                  >
                    <button
                      className={`${
                        styles['no-padding']
                      } btn btn-primary btn-link`}
                      onClick={onShow}
                    >
                      View detail transactions
                    </button>
                  </td>
                </tr>
              </table>
              {FeatureBillingPage.renderAdditionalInfo(featureName)}
              <button
                className={`${styles['btn-use-feature']} btn btn-block ${
                  isButtonDisabled
                    ? `btn-disabled ${styles['disabled-button']}`
                    : 'btn-primary'
                }`}
                disabled={isButtonDisabled}
                onClick={verifyBilling}
              >
                <strong>{buttonMessage}</strong>
              </button>

              {billingMessages && (
                <div className={`row ${styles['pending-notification']}`}>
                  <div className="col-md-12">
                    <em>{billingMessages}</em>
                  </div>
                </div>
              )}
              <p className={styles['feature-message']}>
                Check your <Link to="/settings/billing">billing page</Link> for
                transaction history
              </p>
            </div>
          </div>
        </PageWrapper>
        <FeatureDetailModal
          onHide={onHide}
          showModal={showDetailModal}
          featurePrice={featurePrice}
          outletList={outletList}
          featureName={featureName}
        />
        <PaymentGatewayErrorModal
          showModal={showPaymentGatewayErrorModal}
          onHide={hidePaymentGatewayErrorModal}
          totalPrice={featurePrice.final_price}
        />
      </div>
    );
  }
}

export default FeatureBillingPage;
